export default {
    serverURL:'https://testlcwxw.frensworkz.com/',
    nameTitle:"徕卡企业号",
    wxauth : true //启用企业号页面授权验证
}



// WEBPACK FOOTER //
// ./src/config/config.js